export default __webpack_public_path__ + "static/media/avt.8cd239f5.png";